import { hasNativeEmojiSupport as e, substituteColonifiedForUnicode as t } from "./utils/emoji.js";
import { Mark as n } from "prosemirror-model";
//#region src/document-builder.ts
var r = class {
	schema;
	stack;
	marks;
	docNode;
	constructor(e) {
		this.schema = e, this.stack = [{
			type: e.topNodeType,
			infoContent: [],
			content: []
		}], this.marks = n.none;
	}
	get doc() {
		if (!this.docNode) {
			if (this.stack.length !== 1) throw Error("Document has unclosed nodes");
			this.docNode = this.closeNode();
		}
		return this.docNode;
	}
	top() {
		return this.stack[this.stack.length - 1];
	}
	push(e) {
		this.stack.length && this.top().content.push(e);
	}
	openNode(e, t) {
		this.stack.push({
			type: e,
			attrs: t,
			infoContent: [],
			content: []
		});
	}
	closeNode() {
		let e = this.stack.pop();
		if (!e) throw Error("Tried to close a non existent node");
		let t = e.type.createAndFill(e.attrs, e.content, this.marks);
		if (!t) throw Error("Undefined node type");
		return this.push(t), t;
	}
	addText(n) {
		if (!n) return;
		e() || (n = t(n));
		let r = this.top().content, i = r[r.length - 1], a = this.schema.text(n, this.marks), o = i && this.maybeMerge(i, a);
		o ? r[r.length - 1] = o : r.push(a);
	}
	openMark(e) {
		this.marks = e.addToSet(this.marks);
	}
	closeMark(e) {
		this.marks = e.removeFromSet(this.marks);
	}
	maybeMerge(e, t) {
		if (e.isText && t.isText && n.sameSet(e.marks, t.marks)) return e.withText(e.text + t.text);
	}
};
//#endregion
export { r as DocumentBuilder };
